module.exports = __webpack_public_path__ + "img/v2_6.f0df4237.png";